import styled from 'styled-components';
import { Row, Typography, Button } from 'antd';
import { lightTheme } from '@/styles/themes/light';

const { fonts } = lightTheme;
const { Title, Text } = Typography;

export const Container = styled(Row)`
	padding: 40px;
	background-color: #f8f8f8;
	border-radius: 20px;
`;

export const PageTitle = styled(Title)`
	&& {
		margin: 0;
		font-size: 25px;
		font-weight: 600;
		line-height: 32px;
		letter-spacing: -0.125px;
		color: #262626;
	}
`;

export const SectionTitle = styled(Title)`
	&& {
		margin: 0;
		font-size: 20px;
		font-weight: 600;
		line-height: 32px;
		letter-spacing: -0.1px;
		color: #262626;
	}
`;

export const SectionDescription = styled(Text)`
	&& {
		display: inline-block;
		margin-top: 8px;
		font-size: ${fonts.body.md.fontSize};
		font-weight: ${fonts.label.lg.fontWeight} !important;
		line-height: 24px;
		color: #262626;
	}
`;

export const FormRow = styled(Row)<{ $marginBottom?: string }>`
	margin-bottom: ${({ $marginBottom }) => $marginBottom ?? '0'};
`;

export const LinkButton = styled(Button)`
	&& {
		padding: 8px;
		height: 40px;
		gap: 8px;
		display: flex;
		color: ${lightTheme.palette.primary[500]};

		.anticon {
			color: ${lightTheme.palette.primary[500]};
		}

		&:hover,
		&:focus {
			color: ${lightTheme.palette.primary[700]};

			.anticon {
				color: ${lightTheme.palette.primary[700]};
			}
		}
	}
`;
